import React, { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { useLocation, useParams } from 'react-router-dom'
import "../NoteItemPage/NoteItemPage.css"
import NoteHandler from '../../../Database/handlers/NoteHandler'

export default function NoteItemPage() {
  const noteHandler = new NoteHandler()
  const locationParams = useParams()
  
  const [state, setstate] = useState({
    title:"",description:"",content:""
  })
  useEffect(() => {
    noteHandler.FetchNote(locationParams?.noteName || "").then((note) => {
      console.log(note)
      setstate({
        ...state,
        title: note?.title || "",
        description: note?.description || "",
        content: note?.content || "",
     })
    })
  }, [])
  
  return (
    <div className='Side-Content NoteItem-Page-Container'>
      <h1 className='Note-Title'>{state.title}</h1>
      <h3 className='Note-Desc'>{state.description}</h3>
      <br />
      <hr className='Content-Divider'/>
      <ReactMarkdown children={state.content} />
    </div>
  )
}
